import MicroServicesPage from '../aws/MicroServicesPage';

export default function NetworkManagementPage() {
  return MicroServicesPage('aws-customer-portal-network-management');
}
